export default "__VITE_ASSET__DOVkEozK__"